import { catchError, Observable, throwError } from 'rxjs';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';

import { PermissionsService } from '~app/services/permissions.service';
import { UserService } from '~app/services/user.service';


@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
	constructor(
		private readonly _injector: Injector,
		private readonly _router: Router,
	) {}

	public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		return next.handle(request).pipe(
			catchError((error) => {
				if (error instanceof HttpErrorResponse && error.status === 401) this.logout();
				return throwError(() => error);
			}),
		);
	}

	private logout(): void {
		this._injector.get(PermissionsService).locked = false;
		this._injector.get(UserService).logout();
		void this._router.navigate(['/user/login']);
	}
}
